import React, { Component } from "react";
import ReportHeader from "./Common/ReportHeader";
import Input from "../2/Controls/Input";
import ReportBody from "./Common/ReportBody";
import ReportButton from "./Common/ReportButton";
import Spinner from "../Common/Spinner";
import * as constants from "../../Constatnts";
import * as actionTypes from "../../actionTypes";
import Pagination from "react-js-pagination";
import axios from "axios";
import { Link } from "react-router-dom";
import Autocompletesearch from "../2/Controls/Autocompletesearch";

class PurchaseProjectionReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      products: [],
      stores: [],
      vendors: [],
      merchantVendors: [],
      storeID: "",
      vendorID: "",
      VendorName: "",
      activePage: 1,
      itemsCountPerPage: 50,
      totalItemsCount: 0,
      recordFrom: 1,
      paginationStatus: "No records to display",
      selectedProducts: [], // Track selected product IDs
      selectAll: false, // Track "Select All" status
      transactionType: null,
      ShowPO: "",
      InTopSoldProduct: false,
      mapVendor: false,
      selectedMapVendor: null,
      moqError: "",
      inTopSoldProductNotinCatalog: false,
      inTopSoldProduct: false,
      sku: "",
      barcode: "",
      name: "",
      gid: "",
    };
    this.onStoreChange = this.onStoreChange.bind(this);
    this.onVendorChange = this.onVendorChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.getVendors = this.getVendors.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSelectAll = this.handleSelectAll.bind(this);
    this.handleSelectRow = this.handleSelectRow.bind(this);
    this.generatepo = this.generatepo.bind(this);
    this.parseDeliveryDays = this.parseDeliveryDays.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.saveMapVendor = this.saveMapVendor.bind(this);
    this.handleMOQChange = this.handleMOQChange.bind(this);
    this.getMerchantVendor = this.getMerchantVendor.bind(this);
    this.getSelectedProducts = this.getSelectedProducts.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    // console.log("props",this.props);
    this.setState({ storeID: this.props.user.store.key });
    // console.log("this.props.config.TransactionTypes", this.props.config.TransactionTypes)
    // this.props.config.TransactionTypes
    let inventoryTransactionTypes = this.props.config.TransactionTypes.find(
      (f) =>
        f.Module === "inventory" &&
        !f.IsDeleted &&
        f.TransactionType.trim() === "Purchase Order"
    );

    this.props
      .getUserStores(this.props.user.user.RegistrationID, "")
      .then((stores) => {
        this.setState({ stores: stores });
      });

    this.setState({ transactionType: inventoryTransactionTypes });

    // this.getVendors(this.props.user.user.RegistrationID, 0, 1000).then((vendors) => {
    //     // console.log("vendors", vendors);
    //     this.setState({ vendors: vendors.searchResult ? vendors.searchResult : [] });
    // });
    this.getVendors(this.props.user.store.key);
    this.getMerchantVendor(this.props.user.user.RegistrationID, 0, 1000);

    await this.loadData(
      this.props.user.store.key,
      1,
      this.state.itemsCountPerPage
    );
  }

  async loadData(
    storeid,
    page,
    pageSize = 50,
    vendorID = "",
    showpo = "",
    inTopSold = false,
    inTopSoldProductNotinCatalog = false
  ) {
    try {
      let payloadData = {
        StoreID: storeid,
        page: page,
        pageSize: pageSize,
        InTopSoldProduct: inTopSold,
        InTspButNotinCatalog: inTopSoldProductNotinCatalog,
      };

      if (vendorID !== "") {
        payloadData.VendorID = vendorID;
      }
      if (showpo !== "") {
        payloadData.ShowPO = showpo;
      }
      if (this.state.sku !== "") {
        payloadData.SKU = this.state.sku;
      }
      if (this.state.name !== "") {
        payloadData.Name = this.state.name;
      }
      if (this.state.gid !== "") {
        payloadData.GroupID = this.state.gid;
      }
      if (this.state.barcode !== "") {
        payloadData.BarCode = this.state.barcode;
      }

      // if (inTopSold) {
      //   payloadData.InTopSoldProduct = true;
      // }

      const response = await axios.post(
        "https://posible-reports-45orxt2wla-el.a.run.app/purchaseprojectionreport",
        payloadData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // console.log("purchase response", response);
      let data = response.data;
      if (data.Code == 0) {
        // data.report.map((item) => {
        //   if (!item.PODate) {
        //     item.PODate = "";

        //   }

        // });
        data.report.map((item) => {
          if (!item.PODate) item.PODate = "";
          item.isSelected = false; // यहाँ नई property add करें
        });
        // console.log("report-->", data.report);
        this.setState({
          products: data.report,
          loading: false,
          totalItemsCount: data.totalRecords,
        });
        this.showPaginationStatus();
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      this.setState({ loading: false });
    }
  }
  async getMerchantVendor(
    registrationID,
    from = 0,
    size = 1000,
    option = "active",
    searchText = ""
  ) {
    this.props
      .getVendors(registrationID, from, size, option, (searchText = ""))
      .then((vendors) => {
        if (vendors && vendors.searchResult.length > 0) {
          let merchantvendor = vendors.searchResult.map((item) => {
            return {
              VendorCode: item.VendorCode,
              VendorID: item.key,
              VendorName: item.VendorFirstName + " " + item.VendorLastName,
            };
          });
          //console.log("resvendor", vendors)
          this.setState({ merchantVendors: merchantvendor || [] });
        } else {
          this.setState({ merchantVendors: [] });
        }
      });
  }

  async exportProduct() {
    try {
      let payloadData = {
        StoreID: this.state.storeID,
      };

      if (this.state.vendorID !== "") {
        payloadData.VendorID = this.state.vendorID;
      }
      const response = await axios.post(
        "https://posible-reports-45orxt2wla-el.a.run.app/purchaseprojectionreport",
        payloadData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      if (data.Code == 0) {
        const products = data.report;

        const productsData = products.map((item) => {
          // Parse DeliveryDays if it's a stringified JSON-like object or array
          // let deliveryDays = item.DeliveryDays;
          // try {
          //   // Clean up the string if necessary
          //   if (deliveryDays.startsWith("{") && deliveryDays.endsWith("}")) {
          //     // Check if it's already a valid JSON object
          //     try {
          //       deliveryDays = JSON.parse(deliveryDays); // Try parsing as JSON object
          //       deliveryDays = Object.keys(deliveryDays)
          //         .filter((day) => deliveryDays[day]) // Filter days with `true` value
          //         .join(", "); // Convert to a comma-separated string
          //     } catch (error) {
          //       // If parsing fails, clean up the string and convert it into a valid JSON object
          //       deliveryDays = deliveryDays.replace(/[{}"]/g, ""); // Remove curly braces and quotes
          //       deliveryDays = deliveryDays
          //         .split(",")
          //         .map((day) => `"${day.trim()}":true`)
          //         .join(","); // Add key-value pairs
          //       deliveryDays = JSON.parse(`{${deliveryDays}}`); // Parse into an object
          //       deliveryDays = Object.keys(deliveryDays).join(", "); // Convert to a comma-separated string
          //     }
          //   } else if (deliveryDays.startsWith("[") && deliveryDays.endsWith("]")) {
          //     // Handle array format
          //     deliveryDays = JSON.parse(deliveryDays); // Parse into an array
          //     deliveryDays = deliveryDays.join(", "); // Convert array to a comma-separated string
          //   } else {
          //     // Handle invalid JSON format (e.g., "{\"Wednesday\",\"Friday\",\"Monday\"}")
          //     deliveryDays = deliveryDays.replace(/[{}"]/g, ""); // Remove curly braces and quotes
          //     deliveryDays = deliveryDays.split(",").join(", "); // Convert to comma-separated string
          //   }
          // } catch (error) {
          //   console.error("Error parsing DeliveryDays:", error);
          //   deliveryDays = item.DeliveryDays; // Fallback to the original value if parsing fails
          // }

          // Format dates to MM/DD/YYYY

          let deliveryDays = item.DeliveryDays;
          try {
            // Parse the JSON string if it's a string
            if (typeof deliveryDays === "string") {
              deliveryDays = JSON.parse(deliveryDays);
            }

            // Extract days with true values
            if (typeof deliveryDays === "object" && deliveryDays !== null) {
              deliveryDays = Object.keys(deliveryDays)
                .filter((day) => deliveryDays[day] === true)
                .join(", ");
            } else {
              deliveryDays = String(deliveryDays); // Fallback to string representation
            }
          } catch (error) {
            console.error("Error parsing DeliveryDays:", error);
            deliveryDays = item.DeliveryDays; // Fallback to original value
          }
          const formatDate = (dateString) => {
            const date = new Date(dateString);
            const month = date.getMonth() + 1; // getMonth() returns 0-based month
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
          };

          return {
            ProductID: item.ProductID,
            StoreID: item.StoreID,
            SKU: item.SKU,
            // BarCode: item.BarCode,
            BarCode: Array.isArray(item.BarCode)
              ? item.BarCode.join("\n")
              : typeof item.BarCode === "string" && item.BarCode.includes(",")
              ? item.BarCode.split(",").join("\n")
              : item.BarCode,

            Name: item.Name,
            VendorID: item.VendorID,
            VendorCode: item.VendorCode,
            VendorName: item.VendorName,
            DeliveryDays: deliveryDays, // Use the formatted deliveryDays
            OrderDays: item.OrderDays,
            DailyDemand: item.ActualDailyDemand,
            Frequency: item.Frequency,
            RequirementQty: item.RequirementQty,
            LeadTime: item.LeadTime,
            StockInHand: item.StockInHand,
            ProjectedStockInHandOnDeliveryDay:
              item.ProjectedStockInHandOnDeliveryDay,
            IdealOrderQty: item.IdealOrderQty,
            StockShortageDays: item.StockShortageDays,
            MOQ: item.MOQ,
            ReOrderQty: item.ReOrderQty,
            PONumber: item.PONumber ? item.PONumber : "",
            LastInWardingDate: item.LastInWardingDate
              ? item.LastInWardingDate
              : "",
            LastInWardingNo: item.LastInWardingNo ? item.LastInWardingNo : "",
            PODate: item.PODate ? formatDate(item.PODate) : "", // Assuming ProcessedOn is the PO Dat
            GroupID: item.GroupID ? item.GroupID : "",
          };
        });

        const csvData = constants.objToCSV(productsData);
        const csvBlob = new Blob([csvData], { type: "text/csv" });
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.setAttribute("hidden", "");
        a.setAttribute("href", url);
        a.setAttribute("download", "PurchaseProjectionReport.csv");
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }

  async onStoreChange(evt) {
    let storeID = evt.target.value;

    this.setState({
      storeID: storeID,
    });
  }
  // async getVendors(storeId) {
  //   try {
  //     const response = await axios.get(
  //       `https://posible-reports-302355316035.asia-south1.run.app/getuniquevendor/${storeId}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     //console.log("vendor response", response);
  //     const data = response.data;
  //     if (data.code == 0) {
  //       this.setState({
  //         vendors: data.result.filter(item => {
  //           if (this.InTopSoldProduct) {
  //             return item.InTopSoldProduct === true; // or simply `return item.InTopSoldProduct;`
  //           } else {
  //             return true; // return all items if condition is false
  //           }
  //         }),
  //       });

  //     }
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //     // this.setState({ loading: false });
  //   }
  // }

  async getVendors(storeId, showpo = "", inTopSold = false) {
    try {
      let payloadData = {
        storeId: storeId,
        inTopSoldProduct: inTopSold,
      };
      if (showpo !== "") {
        payloadData.showPo = showpo;
      }
      const response = await axios.post(
        `https://posible-reports-302355316035.asia-south1.run.app/getuniquevendor`,
        payloadData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;

      if (data.code == 0) {
        let filteredVendors = data.result;

        // if (this.state.InTopSoldProduct) {

        //   const topSoldVendorIds = this.products
        //     .filter(product => product.InTopSoldProduct)
        //     .map(product => product.VendorID);

        //   filteredVendors = filteredVendors.filter(
        //     vendor =>
        //       // vendor.InTopSoldProduct === true &&
        //       topSoldVendorIds.includes(vendor.VendorID)
        //   );
        // }

        this.setState({
          vendors: filteredVendors,
        });
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  }

  onSearchClick(
    vendorID = this.state.vendorID,
    showop = this.state.ShowPO,
    inTopSoldProduct = this.state.inTopSoldProduct,
    inTopSoldProductNotinCatalog = this.state.inTopSoldProductNotinCatalog
  ) {
    this.setState({ activePage: 1, recordFrom: 1, loading: true });

    this.loadData(
      this.state.storeID,
      1,
      this.state.itemsCountPerPage,
      vendorID,
      showop,
      inTopSoldProduct,
      inTopSoldProductNotinCatalog
    );
    this.getVendors(
      this.state.storeID,
      showop,
      inTopSoldProduct,
      inTopSoldProductNotinCatalog
    );
  }
  onVendorChange(evt) {
    let id = evt.target.value;

    this.setState({ vendorID: id });
  }

  handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
    let recordFrom = (pageNumber - 1) * this.state.itemsCountPerPage;
    this.setState({ activePage: pageNumber, recordFrom: recordFrom });
    this.loadData(
      this.state.storeID,
      pageNumber,
      this.state.itemsCountPerPage,
      this.state.vendorID,
      this.state.ShowPO,
      this.state.inTopSoldProduct
    );
  }

  showPaginationStatus() {
    // console.log('this.state.recordFrom', this.state.recordFrom)
    let paginationStatus;
    if (this.state.recordFrom + 1 === this.state.totalItemsCount) {
      paginationStatus =
        "Showing " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else if (
      this.state.recordFrom + this.state.itemsCountPerPage + 1 >
      this.state.totalItemsCount
    ) {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        (this.state.recordFrom + this.state.itemsCountPerPage) +
        " of " +
        this.state.totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  // handleSelectAll = (e) => {
  //   const isChecked = e.target.checked;
  //   this.setState({
  //     selectAll: isChecked,
  //     selectedProducts: isChecked
  //       ? this.state.products.map((product) => product.ProductID)
  //       : [],
  //   });
  // };

  handleSelectAll = (e) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => ({
      products: prevState.products.map((product) => ({
        ...product,
        isSelected: isChecked,
      })),
      selectAll: isChecked,
    }));
  };
  // getSelectedProducts = () => {
  //   return this.state.products.filter(product => product.isSelected);
  // };

  // handleSelectRow = (e, productId) => {
  //   const isChecked = e.target.checked;
  //   let updatedSelectedProducts;

  //   if (isChecked) {
  //     updatedSelectedProducts = [...this.state.selectedProducts, productId];
  //   } else {
  //     updatedSelectedProducts = this.state.selectedProducts.filter(
  //       (id) => id !== productId
  //     );
  //   }

  //   this.setState({
  //     selectedProducts: updatedSelectedProducts,
  //     selectAll: updatedSelectedProducts.length === this.state.products.length,
  //   });
  // };

  getSelectedProducts = () => {
    // InTopSoldProduct;
    // ReOrderQty;

    let selectedProducts = [];
    this.state.products
      .filter((p) => p.isSelected)
      .map((m) => {
        const num = parseFloat(m.ReOrderQty.trim());
        let final = 0;
        if (isNaN(num)) {
          // console.log("ReOrderQty is not a valid number");
          final = 0;
        } else if (num === 0) {
          // console.log("ReOrderQty is zero (numeric)");
          final = 0;
        } else {
          console.log("ReOrderQty is not zero");
          final = num;
        }

        if (!m.InTopSoldProduct && final > 0) {
          selectedProducts.push(m);
        } else if (m.InTopSoldProduct) {
          selectedProducts.push(m);
        }
      });

    return selectedProducts;
    // return this.state.products
    //   .filter((p) => p.isSelected)
    //   .map(({ isSelected, ...rest }) => rest);
  };

  handleSelectRow = (e, index) => {
    const isChecked = e.target.checked;

    this.setState((prevState) => {
      const updatedProducts = [...prevState.products];
      updatedProducts[index] = {
        ...updatedProducts[index],
        isSelected: isChecked,
      };

      return {
        products: updatedProducts,
      };
    });
  };
  generatepo = () => {
    // console.log("selectedProducts",this.state.selectedProducts)

    // let generatepoData = this.state.products.filter((p) =>
    //   this.state.selectedProducts.includes(p.ProductID)
    // );
    let generatepoData = this.getSelectedProducts();

    generatepoData.map((item) => {
      if (item.SKU == "") {
        item.SKU = item.GroupID;
        item.ProductID = item.GroupID;
      }
    });

    this.props.history.push({
      pathname: "/home/inventory/newinventory",
      state: {
        transactionType: this.state.transactionType,
        type: actionTypes.INVENTORY_NEW,
        poproducts: generatepoData,
        vendorID: this.state.vendorID,
      },
    });
  };

  parseDeliveryDays(deliveryDays) {
    // Handle null/undefined cases first
    if (deliveryDays == null) {
      return "";
    }

    try {
      // If it's a string, try to parse it as JSON
      if (typeof deliveryDays === "string") {
        // Handle case where string might already be a JSON object
        if (deliveryDays.startsWith("{") && deliveryDays.endsWith("}")) {
          deliveryDays = JSON.parse(deliveryDays);
        }
        // Handle case where string is just comma-separated days
        else if (deliveryDays.includes(",")) {
          return deliveryDays; // Return as-is if already comma-separated
        }
      }

      // If we have an object, extract the days with true values
      if (typeof deliveryDays === "object" && deliveryDays !== null) {
        return Object.keys(deliveryDays)
          .filter((day) => deliveryDays[day] === true)
          .join(", ");
      }

      // For any other case, return string representation
      return String(deliveryDays);
    } catch (error) {
      console.error("Error parsing DeliveryDays:", error);
      // Return original value if parsing fails
      return typeof deliveryDays === "string"
        ? deliveryDays
        : JSON.stringify(deliveryDays);
    }
  }

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; // getMonth() returns 0-based month
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`; // Format as MM/DD/YYYY
  };
  onChangeFilter(event) {
    let value = event.target.value;
    if (value === "true") value = true;
    if (value === "false") value = false;

    this.setState({ ShowPO: value });
    this.onSearchClick(this.state.vendorID, value, this.state.inTopSoldProduct);
  }
  handleMOQChange = (productId, value) => {
    // if (value <= 0) {
    //   this.setState({ moqError: "Product MOQ can not be blank or 0" })
    //   // return false;
    // }
    this.setState((prevState) => ({
      products: prevState.products.map((product) =>
        product.ProductID === productId ? { ...product, MOQ: value } : product
      ),
    }));
  };
  async saveMapVendor() {
    try {
      this.setState({
        loading: true,
      });
      // const productsToUpdate = this.state.products.filter(product =>
      //   this.state.selectedProducts.includes(product.ProductID)
      // )
      const productsToUpdate = this.getSelectedProducts();
      const invalidMOQProduct = productsToUpdate.find(
        (item) => item.MOQ === "" || Number(item.MOQ) <= 0
      );
      if (this.state.selectedMapVendor == null) {
        this.setState({
          loading: false,
        });
        alert("Please select vendor");
        return false;
      }

      // if (invalidMOQProduct) {
      //   this.setState({
      //     moqError: "Product MOQ cannot be blank or 0",
      //     loading: false
      //   });
      //   alert("Product MOQ cannot be blank or 0")
      //   return false;
      // }
      let payloadData = {
        products: productsToUpdate,
        vendor: this.state.selectedMapVendor,
        storeId: this.state.storeID,
      };
      const response = await axios.post(
        "https://posible-reports-45orxt2wla-el.a.run.app/mapvendoronlineitems",
        payloadData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let data = response.data;
      if (data.code == 0) {
        this.setState({
          mapVendor: false,
          selectedMapVendor: null,
          loading: false,
          selectedProducts: [],
          selectAll: false,
        });
        await this.loadData(
          this.props.user.store.key,
          1,
          this.state.itemsCountPerPage
        );
      }
    } catch (error) {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    // console.log("moqError", this.state.moqError)
    return (
      <div className="content-wrapper">
        <section className="content">
          <ReportHeader
            title={"Purchase Projection Report"}
            showBack={true}
            onBack={() => {
              this.props.history.push({
                pathname: "/home/reports/allreport",
              });
            }}
          />
          <ReportBody>
            <div className="row mb-3">
              <div className="col-md-3">
                <label>Store Name</label>
                <select
                  className="form-control"
                  value={this.state.storeID}
                  onChange={this.onStoreChange}
                >
                  {/* <option value="">All Stores</option> */}
                  {this.state.stores
                    .filter((e) => !e.IsDeleted)
                    .map((store) => (
                      <option value={store.key}>
                        {store.StoreCode}-{store.StoreName}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <label>Vendors</label>
                {/* <select
                  className="form-control"
                  value={this.state.vendorID}
                  onChange={this.onVendorChange}
                >
                  <option value=""></option>
                  {this.state.vendors
                    // .filter((e) => !e.IsDeleted)
                    .map((vendor) => (
                      <option value={vendor.VendorID}>
                        {vendor.VendorName}
                      </option>
                    ))}
                </select> */}
                <Autocompletesearch
                  label=""
                  placeholder="Search Vendor"
                  data={this.state.vendors}
                  value={this.state.VendorName}
                  filterKey="VendorName"
                  onSelect={(item) => {
                    // console.log("item->",item)
                    this.setState({
                      vendorID: item.VendorID,
                      VendorName: item.VendorName,
                    });
                    this.onSearchClick(
                      item.VendorID,
                      this.state.ShowPO,
                      this.state.inTopSoldProduct
                    );
                  }}
                  onChange={(value) => {
                    if (!value) {
                      this.setState({ vendorID: "" });
                      this.onSearchClick(
                        "",
                        this.state.ShowPO,
                        this.state.inTopSoldProduct
                      );
                    }
                  }}
                />
              </div>
              <div className="col-md-3">
                <label>Filter by PO</label>
                <select
                  id="poProduct"
                  className="form-control"
                  value={this.state.ShowPO}
                  onChange={this.onChangeFilter}
                >
                  <option value="">All</option>
                  <option value="true">PO created</option>
                  <option value="false">PO not created</option>
                </select>
              </div>
              <div className="col-md-3">
                <label></label>
                <select
                  id="idTopSellingProducts"
                  className="form-control"
                  value={this.state.topSellingProductOption}
                  onChange={(event) => {
                    let value = event.target.value;
                    let inTopSoldProduct = false;
                    let inTopSoldProductNotinCatalog = false;
                    if (value === "1") {
                      inTopSoldProduct = true;
                    }
                    if (value === "2") {
                      inTopSoldProductNotinCatalog = true;
                    }

                    this.setState({ topSellingProductOption: value });
                    this.onSearchClick(
                      this.state.vendorID,
                      this.state.ShowPO,
                      inTopSoldProduct,
                      inTopSoldProductNotinCatalog
                    );
                  }}
                >
                  {/* InTspButNotinCatalog */}
                  <option value="">All</option>
                  <option value="1">Top selling products</option>
                  <option value="2">Top selling products not in catalog</option>
                </select>
              </div>
            </div>
            <br></br>
            <div className="row">
              <div className="col-md-2">
                <Input
                  type="text"
                  label="Product Name"
                  onChange={(value) => {
                    this.setState({ name: value });
                  }}
                  value={this.state.name}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="text"
                  label="Barcode"
                  onChange={(value) => {
                    this.setState({ barcode: value });
                  }}
                  value={this.state.barcode}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="text"
                  label="SKU"
                  onChange={(value) => {
                    this.setState({ sku: value });
                  }}
                  value={this.state.sku}
                />
              </div>
              <div className="col-md-2">
                <Input
                  type="text"
                  label="GroupID"
                  onChange={(value) => {
                    this.setState({ gid: value });
                  }}
                  value={this.state.gid}
                />
              </div>
              <div className="col-md-1" style={{ marginTop: "15px" }}>
                <ReportButton
                  type="export"
                  onClick={() => this.exportProduct()}
                />
              </div>
              <div className="col-md-1" style={{ marginTop: "15px" }}>
                <button
                  type="button"
                  className="btn btn-secondary btn-flat btn-md pull-right"
                  style={{ marginLeft: "5px" }}
                  onClick={() => this.onSearchClick()}
                >
                  Search
                </button>
              </div>
            </div>
            <br></br>
            <div className="row">
              {this.getSelectedProducts().length > 0 && (
                <div
                  className={
                    this.state.vendorID !== "" ? "col-md-1" : "col-md-12"
                  }
                  style={{ marginBottom: "10px" }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary btn-flat btn-md"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ mapVendor: true })}
                  >
                    Map vendor
                  </button>
                </div>
              )}

              {this.getSelectedProducts().length > 0 &&
                this.state.vendorID !== "" && (
                  <div className="col-md-1" style={{ marginBottom: "10px" }}>
                    <button
                      type="button"
                      className="btn btn-secondary btn-flat btn-md"
                      style={{ marginLeft: "5px" }}
                      onClick={() => this.generatepo()}
                    >
                      Generate PO
                    </button>
                  </div>
                )}
            </div>
            <div className="row">
              {this.state.mapVendor && this.getSelectedProducts().length > 0 && (
                <>
                  <div className="col-md-4">
                    <label>Please select vendor to be mapped</label>

                    <Autocompletesearch
                      label=""
                      placeholder="Search Vendor"
                      data={this.state.merchantVendors}
                      value={
                        this.state.selectedMapVendor
                          ? this.state.selectedMapVendor.VendorCode +
                            " " +
                            this.state.selectedMapVendor.VendorName
                          : ""
                      }
                      filterKey="VendorName"
                      onSelect={(item) => {
                        this.setState({
                          // vendorID: item.VendorID,
                          // VendorName: item.VendorName,
                          selectedMapVendor: item,
                        });
                      }}
                      onChange={(value) => {
                        if (!value) {
                          this.setState({ selectedMapVendor: null });
                        }
                      }}
                    />
                    {
                      <label style={{ fontStyle: "italic" }}>
                        {
                          "Please update product MOQ. Product MOQ can not be blank or 0"
                        }
                      </label>
                    }
                    {
                      <label style={{ fontStyle: "italic" }}>
                        If you change the product's vendor, the related
                        calculations will be refreshed the next day when our
                        daily update runs.
                      </label>
                    }
                  </div>
                  <div className="col-md-2" style={{ marginTop: "22px" }}>
                    <button
                      type="button"
                      className="btn btn-primary btn-flat btn-md"
                      style={{ marginLeft: "5px" }}
                      onClick={() => this.saveMapVendor()}
                    >
                      Save
                    </button>
                  </div>
                </>
              )}
            </div>
            {/* <div className="row">
              <div className="col-md-6 pull-right">
                <button
                  type="button"
                  className="btn btn-primary btn-flat btn-md pull-right"
                  style={{ marginLeft: "5px" }}
                  onClick={this.onSearchClick}
                >
                  Search
                </button>
                {this.state.selectedProducts.length > 0 &&
                  this.state.vendorID !== "" && (
                    <button
                      type="button"
                      className="btn btn-primary btn-flat btn-md pull-right"
                      style={{ marginLeft: "5px" }}
                      onClick={() => this.generatepo()}
                    >
                      Generate PO
                    </button>
                  )}
                <ReportButton
                  type="export"
                  onClick={() => this.exportProduct()}
                />
              </div>
            </div> */}
            <div className="row">
              <div className="col-md-12">
                <div
                  style={{ width: "auto", overflowX: "auto" }}
                  className="scroll2"
                >
                  {this.state.loading && <Spinner />}
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            checked={this.state.selectAll}
                            onChange={this.handleSelectAll}
                          />
                        </th>
                        {/* <th>SKU</th>
                        <th>Barcode</th> */}
                        <th>Name</th>
                        {/* <th>Vendor Code</th>
                        <th>Vendor Name</th> */}
                        <th>Vendor</th>
                        <th>Delivery Days</th>
                        <th>Daily Demand</th>
                        <th>MRP</th>

                        {/* <th>Min Date</th>
                        <th>Max Date</th>
                        <th>Days Sale</th>
                        <th>Frequency</th>
                        <th>Requirement Qty</th> */}
                        <th>Stock In Hand</th>
                        <th>Lead Time</th>

                        {/* <th>Projected Stock in Hand on Delivery Day</th>
                        <th>Ideal Order Qty</th> */}
                        <th>Stock Shortage Days</th>
                        <th>MOQ</th>
                        <th>Order Days</th>
                        <th>Re order Qty</th>
                        <th>PONumber</th>
                        <th>PO Date</th>
                        <th>Last Inwarding Date</th>
                        <th>Last Inwarding No</th>
                        <th>GroupID</th>
                        <th>StoreID</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.products.map((product, index) => (
                        <tr key={index}>
                          <td>
                            {product.PODate == "" &&
                              Number(product.ReOrderQty) > 0 && (
                                <input
                                  type="checkbox"
                                  // checked={this.state.selectedProducts.includes(
                                  //   product.ProductID
                                  // )}
                                  checked={product.isSelected}
                                  onChange={(e) =>
                                    this.handleSelectRow(e, index)
                                  }
                                />
                              )}
                          </td>
                          {/* <td>{product.SKU}</td>
                          <td>{product.BarCode}</td> */}
                          {/* <td>
                            {product.Name}<br />
                            SKU:{product.SKU}<br />
                            Barcode:{product.BarCode}

                          </td> */}
                          <td>
                            <div
                              style={{ lineHeight: "1.5", fontSize: "14px" }}
                            >
                              <strong>{product.Name}</strong>
                              <br />
                              <span>SKU: {product.SKU}</span>
                              <br />
                              {/* <span>Barcode: {product.BarCode}</span> */}
                              <div
                                style={{
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                }}
                              >
                                Barcode: {product.BarCode}
                              </div>
                            </div>
                          </td>

                          {/* <td>{product.VendorCode}</td> */}
                          <td>
                            VendorCode:{product.VendorCode}
                            <br />
                            VendorName:{product.VendorName}
                            <br />
                            {product.IsVendorUpdated && (
                              <label
                                style={{ fontStyle: "italic", color: "green" }}
                              >
                                Vendor mapping updated
                              </label>
                            )}
                          </td>
                          <td>
                            {this.parseDeliveryDays(product.DeliveryDays)}
                          </td>
                          <td>{product.ActualDailyDemand}</td>
                          <td>{product.MRP}</td>
                          {/* 
                          <td>{product.DailyDemand}</td>
                          <td>{product.MinDate}</td>
                          <td>{product.MaxDate}</td>
                          <td>{product.DurationDaysSale}</td>
                          <td>{product.Frequency}</td>
                          <td>{product.RequirementQty}</td> */}
                          <td>{product.StockInHand}</td>
                          <td>{product.LeadTime}</td>

                          {/* <td>{product.ProjectedStockInHandOnDeliveryDay}</td>
                          <td>{product.IdealOrderQty}</td>*/}
                          <td>{product.StockShortageDays}</td>
                          {/* {(this.state.mapVendor && this.state.selectedProducts.includes(product.ProductID)) ?
                            <input
                              autofocus={true}
                              type="number"
                              style={{
                                width: '60px',
                                height: '100%',  // Make height 100% of td
                                border: this.state.moqError ? '1px solid red' : '1px solid #F0F2F5 ',

                                padding: '8px',  // Match table cell padding
                                boxSizing: 'border-box', // Include padding in height calculation
                                //outline: 'none' // Remove default focus outline if needed
                              }}
                              onChange={(e) => {

                                this.setState({ moqError: "" })
                                this.handleMOQChange(product.ProductID, e.target.value)
                              }}
                              value={product.MOQ} />
                            :
                            <td>{product.MOQ}</td>} */}
                          <td>{product.MOQ}</td>
                          <td>{product.OrderDays}</td>
                          <td>{product.ReOrderQty}</td>
                          <td>
                            {product.PONumber !== null && (
                              <Link
                                to={{
                                  pathname: `/home/inventory/viewinventory/${product.POId}`,
                                  state: {
                                    backPath:
                                      "/home/reports/purchaseprojectionreport",
                                  },
                                }}
                              >
                                <span>{product.PONumber}</span>
                              </Link>
                            )}
                          </td>
                          <td>
                            {product.PODate != ""
                              ? this.formatDate(product.PODate)
                              : ""}
                          </td>
                          <td>{product.LastInWardingDate}</td>
                          <td>
                            <Link
                              to={{
                                pathname: `/home/inventory/viewinventory/${product.LastInWardingID}`,
                                state: {
                                  backPath:
                                    "/home/reports/purchaseprojectionreport",
                                },
                              }}
                            >
                              <span>{product.LastInWardingNo}</span>
                            </Link>
                          </td>
                          <td>{product.GroupID}</td>
                          <td>{product.StoreID}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {this.state.totalItemsCount > 0 && (
              <div className="pull-left" style={{ marginTop: "25px" }}>
                {this.state.paginationStatus}
              </div>
            )}
            <div className="pull-right">
              <Pagination
                activePage={this.state.activePage} //this.state.activePage
                itemsCountPerPage={this.state.itemsCountPerPage}
                totalItemsCount={this.state.totalItemsCount}
                pageRangeDisplayed={2}
                onChange={this.handlePageChange}
              />
            </div>
          </ReportBody>
        </section>
      </div>
    );
  }
}

export default PurchaseProjectionReport;
